// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3ML99","sliderInput":"Slider_sliderInput__l7Uig"};